module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/id_tohoku-4cac2f047b6860badcf45aebfc72cd3b.jpg";